export interface Brand {
  name: string;
  slug: string;
  homepage: string;
  regions: string[];
  focus: string[];
}

// Static brands data - in real implementation, this would be loaded from YAML
export const brands: Brand[] = [
  {
    name: "Bizon (Publicis Groupe)",
    slug: "bizon",
    homepage: "https://www.bizon.solutions/",
    regions: ["FR","EU"],
    focus: ["Amazon Ads","SEO Amazon","Ops","Retail Media"]
  },
  {
    name: "DEPT (ex factor-a)",
    slug: "dept",
    homepage: "https://www.deptagency.com/",
    regions: ["DE","EU","UK"],
    focus: ["Retail Media","Amazon Ads","SEO Amazon","Creative"]
  },
  {
    name: "e-Comas",
    slug: "e-comas",
    homepage: "https://e-comas.com/",
    regions: ["EU","UK"],
    focus: ["Amazon Ads","SEO Amazon","Ops","Expansion EU"]
  },
  {
    name: "Optimizon",
    slug: "optimizon",
    homepage: "https://www.optimizon.co.uk/",
    regions: ["UK","EU"],
    focus: ["Amazon Ads","SEO Amazon","Ops"]
  },
  {
    name: "Clear Ads",
    slug: "clear-ads",
    homepage: "https://clearadsagency.com/",
    regions: ["UK","EU"],
    focus: ["Amazon Ads","DSP","PPC"]
  },
  {
    name: "Tambo (Luzern eCommerce)",
    slug: "tambo",
    homepage: "https://www.tambo.io/",
    regions: ["UK","EU"],
    focus: ["Amazon Ads","Consulting","Data/Tools"]
  },
  {
    name: "Acadia (ex Bobsled Marketing)",
    slug: "acadia",
    homepage: "https://acadia.io/services/retail-media-marketplaces/amazon-consulting/",
    regions: ["US","EU","UK"],
    focus: ["Amazon Ads","SEO Amazon","Ops"]
  },
  {
    name: "Channel Bakers (Havas Market)",
    slug: "channel-bakers",
    homepage: "https://www.channelbakers.com/",
    regions: ["US","EU","UK","APAC"],
    focus: ["Retail Media","Amazon Ads","Creative"]
  },
  {
    name: "Pattern (Accelerator)",
    slug: "pattern",
    homepage: "https://pattern.com/",
    regions: ["US","EU","UK"],
    focus: ["Marketplace Accelerator","Retail Media","Ops"]
  },
  {
    name: "eStore Factory",
    slug: "estore-factory",
    homepage: "https://www.estorefactory.com/",
    regions: ["UK","EU","IN","US"],
    focus: ["Amazon Ads","SEO Amazon","Content","Ops"]
  },
  {
    name: "MarginBusiness",
    slug: "marginbusiness",
    homepage: "https://marginbusiness.com/",
    regions: ["EU"],
    focus: ["SEO Amazon","Listings","PPC"]
  },
  {
    name: "Seelk (Jellyfish)",
    slug: "seelk-jellyfish",
    homepage: "https://www.seelk.co/",
    regions: ["FR","EU","US"],
    focus: ["Retail Media","Analytics","Consulting"]
  }
];

export const getBrandBySlug = (slug: string): Brand | undefined => {
  return brands.find(brand => brand.slug === slug);
};

export const isProduction = () => {
  const hostname = window.location.hostname;
  // Consider as production if:
  // 1. On cosmos-wave.com or www.cosmos-wave.com
  // 2. NOT on a lovable preview domain
  return (
    hostname === 'cosmos-wave.com' || 
    hostname === 'www.cosmos-wave.com' ||
    (!hostname.includes('lovable.app') && !hostname.includes('localhost'))
  );
};